import Splide from '@splidejs/splide';

export function initSubcategorySlider() {
  const subcategory = document.querySelector('.popular-subcategory__slider');

  if (subcategory) {
    const splide = new Splide(subcategory, {
      mediaQuery: 'max',
      fixedWidth: '100px',
      perPage: 9,
      arrowPath: 'M16.802 19.9948L31.7358 4.87181C32.8402 3.75247 32.8402 1.94248 31.7358 0.835045C30.6313 -0.284294 28.8454 -0.272386 27.7409 0.835045L10.8215 17.9705C9.75229 19.0541 9.7288 20.7926 10.7393 21.912L27.7291 39.1664C28.2814 39.7261 29.0099 40 29.7266 40C30.4433 40 31.1718 39.7261 31.724 39.1664C32.8285 38.0471 32.8285 36.2371 31.724 35.1297L16.802 19.9948Z',
      classes: {
        arrows: 'splide__arrows popular-subcategory__arrows',
        arrow: 'splide__arrow popular-subcategory__arrow',
        prev: 'splide__arrow--prev popular-subcategory__arrow--prev',
        next: 'splide__arrow--next popular-subcategory__arrow--next',
        pagination: 'splide__pagination popular-subcategory__pagination',
      },
      gap: '20px',
      breakpoints: {
        '991': {
          perPage: 6
        },
        '767': {
          destroy: true
        }
      }
    });

    splide.mount();
  }

}
